import * as React from 'react';

import {Circle} from 'react-native-svg';
import {Icon} from '.';
import {IconProps} from './type';

const CircleoutlinedIcon: React.FC<IconProps> = props => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Circle cx={13} cy={12} r={6.5} stroke="#40D689" />
    </Icon>
  );
};

export default CircleoutlinedIcon;
